import { Directive, ElementRef, Renderer2 } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Directive({
  selector: '[hideInProduction]'
})
export class HideInProductionDirective {
  constructor(private el: ElementRef, private renderer: Renderer2) {
    if (environment.production) {
      this.renderer.removeChild(this.el.nativeElement.parentNode, this.el.nativeElement);
    }
  }
}
